import React from "react";

interface IWindowContainer {
  children?: React.ReactNode;
  type?: "default" | "fullsize" | "small";
}

// TODO: Rename?
const WindowContainer = ({ children, type = "default" }: IWindowContainer) => {
  // set window size classes based on size prop
  const windowTypeClasses = `${
    type === "fullsize" && "min-h-[32rem] h-full w-full"
  } ${type === "default" && "min-h-[32rem] h-fit w-full lg:w-[56rem]"} ${
    type === "small" && "h-fit w-1/3"
  }`;

  return (
    <div
      className={`bg-black/[0.35] rounded-[3rem] p-8 relative ${windowTypeClasses} flex items-center`}
    >
      <div className="bg-black/[0.25] rounded-t-[3rem] h-14 md:h-16 w-full absolute top-0 left-0 flex items-center px-8">
        <div className="rounded-full bg-icons-close h-4 w-4 mx-1 hidden md:block" />
        <div className="rounded-full bg-icons-minimize h-4 w-4 mx-1 hidden md:block" />
        <div className="rounded-full bg-icons-maximize h-4 w-4 mx-1 hidden md:block" />
        <span className="text-backgroundLight/[0.4] uppercase text-xs md:hidden">
          {"<  Back"}
        </span>
      </div>
      {children}
    </div>
  );
};

export default WindowContainer;
